export const getPriceSign = '$';

export const getPriceFormat = (price = 0, unit = '$', unitText = '', fractionDigits = 2) => {
  if (typeof price === 'string' && isNaN(+price)) return null;
  price = +price;
  return `${unitText} ${unit}${price.toFixed(fractionDigits)}`;
};
